// extracted by mini-css-extract-plugin
export default {"formBox":"LoginPage_formBox__17iaU","formContainer":"LoginPage_formContainer__bwXr9"};